import { createContext } from 'react';
import type { User } from '@/types';

export interface AuthContextValue {
  loading: boolean;
  user: User | null;
  isAuthenticated: boolean;
  loggedOut: boolean;
  authError: string | null;
  signInWithEmailPassword: (email: string, password: string) => Promise<void>;
  signInWithGoogleAccount: () => Promise<void>;
  signOut: () => Promise<void>;
  sendPasswordReset: (email: string) => Promise<void>;
  clearAuthError: () => void;
  devLogin: () => void;
}

export const AuthContext = createContext<AuthContextValue | null>(null);
